// src/utils/editor/autoResize.js


// Function to resize a specific textarea on content change
export const autoResize = (element) => {
  if (element) {
    const numLines = element.value.split('\n').length;
    const lineHeight = parseFloat(window.getComputedStyle(element).lineHeight);
    const height = numLines * lineHeight;
    element.style.height = `${height}px`; // Adjust height based on the number of lines
  }
};
